// extracted by mini-css-extract-plugin
export default {"root":"TreePromoDesktopApp__root--2kIpW","logo":"TreePromoDesktopApp__logo--1Nuaq","text":"TreePromoDesktopApp__text--3kPs5"};